import React from 'react'
import st from './WhatsAppPreview.module.scss'

const formatTime = () => {
  const d = new Date()
  return `${String(d.getHours()).padStart(2, '0')}:${String(
    d.getMinutes(),
  ).padStart(2, '0')}`
}

export const WhatsAppPreview = ({ text }) => (
  <div className={st.chat}>
    <div className={st.bubble}>
      <span className={st.message}>{text || 'Пустое сообщение'}</span>
      <span className={st.time}>
        {formatTime()} <span className={st.checks}>✓✓</span>
      </span>
    </div>
  </div>
)
